import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireCompetition} from '../umpire-competition';
import {UmpireStatistic} from '../umpire-statistic';

export interface UmpireComponentCompetitionSeasonStatistics
  extends UmpireComponent<UmpireComponentTypeEnum.COMPETITION_SEASON_STATISTICS> {
  resource_type: 'SquadPlayer' | 'Squad';
  statistics_type: string;
  competition: UmpireCompetition;
  statistics: UmpireStatistic[];
}
